module.exports = __webpack_public_path__ + "media/src/images/favicon/site-80b0c9054ec2196349eeb7839ab465b2.webmanifest";